@if (page$ | async; as page) {
  <article class="content-page">
    <!-- <app-header [title]="page.title" [text]="page.intro" [image]="page.image"></app-header> -->
    <app-header-article [title]="page.title" [intro]="page.intro" [media]="page.image">
      <app-breadcrumbs slot="breadcrumbs" [breadcrumbs]="breadcrumbs" class="d-block mb-4"></app-breadcrumbs>
    </app-header-article>
    <main class="content-page__body container container-size-sm section-inset-y">
      @if (page.text) {
        <div
          class="markdown-content"
          [innerHTML]="page.text | stripEmbed: (cookiesAccepted$ | async) ?? undefined | safe"
          fstrDynamicContent
        ></div>
      }
    </main>
    <app-content-block-container [blocks]="page.contentBlocks"></app-content-block-container>
  </article>
}
<!-- background-color: var(--bg-background); -->
